function ArrowLeft(props) {
  return (
    <svg
      width={60}
      height={34}
      viewBox="0 0 60 34"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M49.542 8l-1.42 1.381 5.29 5.146H3v1.946h50.412l-5.29 5.146L49.542 23l5.58-5.438a2.862 2.862 0 000-4.124L49.543 8z"
        fill="#0FB960"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default ArrowLeft;
